import { type } from 'arktype';

export const shiftAssignmentQuerySchema = type({
  'planId?': 'string',
  'planVersionId?': 'string',
  'shiftId?': 'string',
  'employeeId?': 'string',
  'personId?': 'string',
  'status?': 'string',
  /** ISO date — exact match (YYYY-MM-DD) */
  'date?': 'string',
  /** ISO date — lower bound inclusive (YYYY-MM-DD) */
  'dateFrom?': 'string',
  /** ISO date — upper bound inclusive (YYYY-MM-DD) */
  'dateTo?': 'string',
});

export type ShiftAssignmentQuery = typeof shiftAssignmentQuerySchema.t;

export const createShiftAssignmentSchema = type({
  shiftId: type('string').configure({
    description: 'ID of the shift the employee is being assigned to.',
    examples: ['shift_abc123'],
  }),
  employeeId: type('string').configure({
    description: 'ID of the employee being assigned to the shift.',
    examples: ['employee_abc123'],
  }),
  'status?': type('string').configure({
    description: "Initial assignment status (e.g. 'confirmed', 'tentative'). Defaults to the service default.",
    examples: ['confirmed'],
  }),
}).configure({ description: 'Payload for creating a shift assignment linking an employee to a shift.' });

export type CreateShiftAssignment = typeof createShiftAssignmentSchema.t;

export const updateShiftAssignmentSchema = type({
  'status?': type('string').configure({
    description: "Updated assignment status (e.g. 'confirmed', 'tentative', 'cancelled').",
    examples: ['confirmed'],
  }),
}).configure({ description: 'Partial update of a shift assignment — only `status` is mutable.' });

export type UpdateShiftAssignment = typeof updateShiftAssignmentSchema.t;
